// ... existing code ...
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画网-免费韩漫大全-最新热门在线漫画阅读"
        description="韩国漫画网提供海量免费韩漫在线阅读，每日更新最新热门作品，涵盖校园、恋爱、奇幻、热血等全品类题材。无广告干扰，高清画质，无需注册即可畅享优质漫画阅读体验，是韩漫爱好者的首选平台。"
        keywords="韩国漫画网,免费韩漫,漫画大全,在线漫画,韩漫,免费漫画,漫画平台,看漫画,最新韩漫,热门漫画"
        canonicalUrl="http://w0ap.com/"
        breadcrumbs={[
          { label: '首页', path: '/' },
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '韩国漫画网 - 首页',
          description: '韩国漫画网提供海量免费韩漫在线阅读，每日更新最新热门作品。',
          url: 'http://w0ap.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩国漫画网',
            url: 'http://w0ap.com/',
          },
          about: {
            '@type': 'Thing',
            name: '韩国漫画',
            description: '韩国漫画在线阅读平台，提供免费韩漫资源',
          },
        }}
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩国漫画网',
            alternateName: 'KMANHUA',
            url: 'http://w0ap.com/',
            description: '韩国漫画网是专业的免费韩漫在线阅读平台，提供海量韩国漫画资源，每日更新最新热门作品。',
            foundingDate: '2023',
            email: 'hello@w0ap.com',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressCountry: 'CN',
            },
            sameAs: ['http://w0ap.com/'],
          }),
        }}
      />

      {/* Website Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩国漫画网',
            alternateName: 'KMANHUA',
            url: 'http://w0ap.com/',
            description: '韩国漫画网提供海量免费韩漫在线阅读，每日更新最新热门作品，涵盖校园、恋爱、奇幻、热血等全品类题材。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'http://w0ap.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <LatestSection />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}